import {Component, OnInit, ViewChild} from '@angular/core';
import {IonInput, ModalController} from '@ionic/angular';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {BaseModalComponent} from '../base-modal.component';
import {AuthenticationService} from '../../_services/authentication.service';
import {UserService} from '../../_services/user.service';
import {ToastService} from '../../_services/toast.service';
import {LoadingService} from '../../_services/loading.service';
import {User} from '../../_models/user';

@Component({
    selector: 'bb-confirm-email',
    templateUrl: './confirm-email.component.html',
    styleUrls: ['./confirm-email.component.scss'],
})
export class ConfirmEmailComponent extends BaseModalComponent implements OnInit {
    @ViewChild('codeInput') codeInput: IonInput;
    firstInput: IonInput;
    formGroup: FormGroup;
    currentUser: User;
    returnUrl: string;

    @ViewChild('firstInput') set first(input: IonInput) {
        this.firstInput = input;
        this.setFirstInputFocus();
    }

    constructor(
        private authenticationService: AuthenticationService,
        private userService: UserService,
        private toastService: ToastService,
        private loadingService: LoadingService,
        private formBuilder: FormBuilder,
        modalController: ModalController
    ) {
        super(modalController);
    }

    ngOnInit(): void {
        this.currentUser = this.userService.currentValue;
        this.authenticationService.returnUrl.subscribe(url => this.returnUrl = url);

        this.formGroup = this.formBuilder.group({
            code: ['', [Validators.required, Validators.maxLength(6), Validators.minLength(6)]]
        });
    }

    cancel() {
        this.close(false);
    }

    async submit() {
        this.loadingService.present();
        this.userService.confirmEmail(this.formGroup.controls.code.value).subscribe(async (user: User) => {
                this.loadingService.dismiss();
                await this.authenticationService.setupUser(user);
                this.close('SUCCESS');
            },
            error => {
                if (error.status === 423) {
                    this.toastService.error('The confirmation code has expired. Please click resend to generate a new code.');
                    this.formGroup.controls.code.setValue('');
                } else if (error.status === 409) {
                    this.toastService.error('The confirmation code is incorrect.');
                    this.formGroup.controls.code.setValue('');
                }
            });
    }

    async resend() {
        this.loadingService.present();
        this.userService.resendConfirmation().subscribe((response: any) => {
            this.loadingService.dismiss();
            this.toastService.success(`A new code has been sent to ${response.email}.`);
        });
    }

    setFirstInputFocus() {
        if (!!this.firstInput) {
            setTimeout(async () => {
                await this.firstInput.setFocus();
            }, 250);
        }
    }
}
